export { default as AlertsWidget } from "./AlertsWidget"


// WEBPACK FOOTER //
// ./src/modules/dashboard/Widgets/index.ts